import React, { useEffect } from "react";
import { styled } from "@mui/material/styles";
import { Box, Container, Grid, Typography } from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import FormLogin from "./components/FormLogin";

const Item = styled(Box)(({ theme }) => ({
  backgroundColor: "#121212",
  color: theme.palette.text.secondary,
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

export default function Login({ sessionActive, setSessionActive }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionActive) {
      navigate("/dashboard");
    }
  }, [sessionActive, navigate]);

  return (
    <Container maxWidth="xl">
      <Item>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} sx={{ textAlign: "center", padding: 4 }}>
            {/* <img src={Logo} alt="Logo PM" style={{ maxWidth: "100%", height: "auto" }} /> */}
            <Typography
              variant="h4"
              gutterBottom
              sx={{ marginTop: 3, fontWeight: "700" }}
            >
              ¡BIENVENIDO A WE FUNDS TRADE!
            </Typography>

            <Typography variant="body1" sx={{ marginBottom: 4 }}>
              Has llegado a tu portal personal. <br />
              Aquí puedes dar seguimiento a tus inversiones y a cada movimiento del sistema en tiempo real.
            </Typography>

            <Typography variant="body1" sx={{ marginBottom: 4 }}>
              ¿Aún no eres parte? <br />
              Invierte desde $10 USD y accede al sistema.
              Regístrate ahora.
            </Typography>

            <div style={{ textAlign: "center", marginTop: 20 }}>
              <Link to="/registro" style={{ backgroundColor: "#fff", color: "#000", padding: "10px 20px", borderRadius: "5px", textDecoration: "none" }}>
                Registrate aquí
              </Link>
            </div>
            
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              backgroundColor: "#1e1e1e",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              padding: 4,
              borderRadius: 5,
            }}
          >
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                textAlign: "center",
                paddingTop: 2,
                paddingBottom: 4,
                fontWeight: "600",
              }}
            >
              Iniciar sesión
            </Typography>
            <FormLogin setSessionActive={setSessionActive} />
          </Grid>
        </Grid>
      </Item>
    </Container>
  );
}
